import React from "react";
import { useRecoilValueLoadable } from "recoil";
import { currentTranslations } from "../atoms/i18n";
import Loading from "./Loading";

type I18nGuardProps = {
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

/**
 * This component is here to ensure all sub-components using i18n won't trigger a suspense
 * Especially useful when dealing with React navigation component caching.
 */
const I18nGuard: React.FC<I18nGuardProps> = ({ children, fallback }) => {
    const i18nLoadable = useRecoilValueLoadable(currentTranslations);
    if (i18nLoadable.state === "hasValue") {
        return <>{children}</>;
    }
    if (i18nLoadable.state === "loading") {
        return <>{fallback}</> || <Loading />;
    }
    if (i18nLoadable.state === "hasError") {
        throw i18nLoadable.contents;
    }
    return null;
};

export default I18nGuard;
